import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import LandingPage from './pages/LandingPage';
import LoadingSkeleton from './components/landing/LoadingSkeleton';
import EmailCapture from './components/portfolio/EmailCapture';
import PublicScore from './components/scoring/PublicScore';
import PremiumPlans from './components/scoring/PremiumPlans';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/Dashboard';
import PrivateRoute from './components/auth/PrivateRoute';
import PremiumSignupPage from './pages/PremiumSignupPage'
import SignupConfirmation from './components/auth/SignupConfirmation'

import Account from './components/account/Account'
import ETFList from './components/etf/ETFList';

import PortfolioPage from './components/portfolio/PortfolioPage'

import { Box } from '@mui/material';

import PageViewTracker from './components/common/PageViewTracker';
import Terms from './components/legal/Terms';
import Privacy from './components/legal/Privacy';

function App() {
  return (
    <Router>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh', // Ensure minimum height of viewport
        }}
      >
        <Navbar />
        <Box
          component="main"
          sx={{
            flex: 1, // Take up remaining space
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <PageViewTracker />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/etfs" element={<ETFList />} />

            <Route path="/portfolio" element={<PortfolioPage/>}/>
            <Route path="/score/loading" element={<LoadingSkeleton />} />
            <Route path="/score/email" element={<EmailCapture />} />
            <Route path="/score/:scoreId" element={<PublicScore />} />
            <Route path="/premium" element={<PremiumPlans />} />
            <Route path="/signup/premium" element={<PremiumSignupPage />} />
            <Route path="/signup/confirm" element={<SignupConfirmation />} />

            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            
            
            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />

            <Route path="/account" element={
              <PrivateRoute>
                <Account />
              </PrivateRoute>
            } />

            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

          </Routes>
        </Box>
        <Footer />
      </Box>
    </Router>
  );
}

export default App;